import { ChainId } from "@layerzerolabs/lz-sdk";
import { Token } from "@layerzerolabs/x-trader-joe-bridge";

const tokens = [
  // @layerzerolabs/solidity-examples/contracts/token/oft/v1/OFT.sol
  // remoteOFT (bridged version of the original erc20 on destination chain)
  // For deployment how-to, refer the file "solidity-examples\_deployment\goerli-bsc-testnet-v1.txt"
  new Token(
    ChainId.BSC_TESTNET, // destination chain
    "0xf292b9aad24b19eF2135D56d34647764A2494508",
    18,
    "AVA"
  ),

  // Other destination chains can be added here
  // @layerzerolabs/solidity-examples/contracts/token/oft/v2/fee/OFTWithFee.sol
  // remoteOFT (bridged version of the original erc20 on destination chain)
  // For deployment how-to, refer the file "solidity-examples\_deployment\goerli-bsc-testnet-v1.txt"
  // new Token(
  //   ChainId.ARBITRUM_GOERLI, // destination chain
  //   "0x???",
  //   18,
  //   "AVA"
  // ),
  /////////////////////////////////////////////

  // Original erc20 token
  new Token(
    ChainId.GOERLI, // source chain
    "0xc02C3E37DeE3579621eAfDA5c33159e7f7FaabF9",
    18,
    "AVA"
  ),
];

const proxy = [
  {
    // @layerzerolabs/solidity-examples/contracts/token/oft/v1/ProxyOFT.sol
    // localOFT (proxy version of the original erc20 on source chain)
    // For deployment how-to, refer the file "solidity-examples\_deployment\goerli-bsc-testnet-v1.txt"
    chainId: ChainId.GOERLI,
    address: "0xeD6BD8A99cf2Cf6C6F6EA272ECdCcB392C383378",
  },
];

export const tokens_testnet = { tokens, proxy };
